window.replaceUploadedPropertyWithPopup = () => {
  const DRAWER_SEL = '#CartPopup';
  const ITEM_SEL = '.upcart-product-item';
  const PROP_SEL = '.upcart-item-property';
  const MATCH_TEXT = 'upload photo';

  const css = `
  #upload-photo-modal{position:fixed;inset:0;display:none;align-items:center;justify-content:center;z-index:2147483647;background:rgba(0,0,0,.5)}
  #upload-photo-modal.open{display:flex}
  #upload-photo-modal .modal-content{background:#fff;width:min(92vw,960px);height:min(92vh,760px);border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.25);display:flex;flex-direction:column;overflow:hidden}
  #upload-photo-modal header{display:flex;align-items:center;gap:8px;justify-content:space-between;padding:12px 16px;border-bottom:1px solid #e5e7eb}
  #upload-photo-modal header h3{font-size:16px;margin:0;font-weight:600}
  #upload-photo-modal header .actions{display:flex;align-items:center;gap:12px}
  #upload-photo-modal header a{font-size:13px;text-decoration:underline}
  #upload-photo-modal button.modal-close{appearance:none;background:#f3f4f6;border:1px solid #e5e7eb;border-radius:8px;padding:6px 10px;cursor:pointer;font-size:14px}
  #upload-photo-modal button.modal-close:hover{background:#e5e7eb}
  #upload-photo-modal .frame-wrap{flex:1;min-height:0}
  #upload-photo-modal iframe{border:0;width:100%;height:100%}
  .upload-photo-btn{display:inline-flex;align-items:center;gap:8px;padding:8px 12px;border-radius:8px;border:1px solid #111;background:#111;color:#fff;cursor:pointer;font-size:14px;line-height:1.2}
  .upload-photo-btn:hover{opacity:.92}
  `;

  function injectStyles() {
    if (document.getElementById('upload-photo-style')) return;
    const style = document.createElement('style');
    style.id = 'upload-photo-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // --- Modal singleton ---
  function ensureModal() {
    let modal = document.getElementById('upload-photo-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'upload-photo-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="modal-content" role="dialog" aria-modal="true" aria-label="Upload photo">
        <header>
          <h3>Upload photo</h3>
          <div class="actions">
            <a href="#" target="_blank" rel="noopener" id="upload-photo-open-tab" aria-label="Open in new tab">Open in new tab</a>
            <button type="button" class="modal-close" aria-label="Close">Close</button>
          </div>
        </header>
        <div class="frame-wrap">
          <iframe id="upload-photo-iframe" src="about:blank"></iframe>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    const close = () => {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      const iframe = modal.querySelector('#upload-photo-iframe');
      if (iframe) iframe.src = 'about:blank';
    };

    modal.addEventListener('click', (e) => {
      if (e.target === modal) close();
    });
    modal.querySelector('.modal-close').addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (modal.classList.contains('open') && e.key === 'Escape') close();
    });

    return modal;
  }

  function openUploadModal(url) {
    const modal = ensureModal();
    const iframe = modal.querySelector('#upload-photo-iframe');
    const openTab = modal.querySelector('#upload-photo-open-tab');
    openTab.href = url || '#';
    if (url) iframe.src = url;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function enhanceProperties(root) {
    const props = root.querySelectorAll(PROP_SEL);
    props.forEach((propEl) => {
      if (propEl.dataset.uploadEnhanced === '1') return;

      const text = (propEl.textContent || '').toLowerCase();
      if (!text.includes(MATCH_TEXT)) return;

      const valueSpan = propEl.querySelector('span');
      const rawUrl = (valueSpan?.textContent || '').trim();
      if (!rawUrl) {
        propEl.dataset.uploadEnhanced = '1'; 
        return;
      }

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'upload-photo-btn';
      btn.textContent = 'Upload photo';
      btn.setAttribute('data-upload-link', rawUrl);

      propEl.replaceWith(btn);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button.upload-photo-btn[data-upload-link]');
    if (!btn) return;
    const url = btn.getAttribute('data-upload-link');
    openUploadModal(url);
  });

  function watchDrawer(drawer) {
    const debounced = debounce(() => enhanceProperties(drawer), 80);
    const mo = new MutationObserver(debounced);
    mo.observe(drawer, { childList: true, subtree: true });
    
    enhanceProperties(drawer);
  }

  
  function init() {
    injectStyles();
    const drawerNow = document.querySelector(DRAWER_SEL);
    if (drawerNow) {
      watchDrawer(drawerNow);
      return;
    }
    
    const mo = new MutationObserver(() => {
      const drawer = document.querySelector(DRAWER_SEL);
      if (drawer) {
        mo.disconnect();
        watchDrawer(drawer);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function debounce(fn, wait) {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

